<style scoped>
    span.matrix_param {
        cursor: pointer;
    }
    span.matrix_param:hover {
        color: var(--hovercolor);
    }
</style>

<template>
    <div>
        <!-- main page -->
        <div class="vx-row mb-12">
            <div class="vx-col sm:w-1/1 w-full mb-base">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">{{this.dataEnd==0 ? 0: (this.limitShow * (this.isActive - 1) + 1)}} - {{this.limitShow * (this.isActive - 1) + dataEnd}} of {{this.recordsTotal}}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="item in limits" v-bind:key="item" @click="changeLimit(item)">
                                    <span>{{item}}</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <div class="mx-auto">
                        <vs-button
                            class="mt-2"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="clickCreate()"
                        >Create</vs-button>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <div class="flex flex-wrap items-center justify-between">
                            <vs-input class="mb-4 md:mb-0 mr-4 w-full" v-model="search" placeholder="Search by : Matrix Code, Name, or Description" />
                        </div>
                    </div>
                </div>

                <vs-table :data="dataMatrix" stripe border>
                    <template slot="thead">
                        <vs-th>Matrix</vs-th>
                        <vs-th>Detail</vs-th>
                        <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="idx" v-for="(dt, idx) in data">
                            <vs-td style="width:20%">
                                Code : {{dt.Code}}<br>
                                Name : {{dt.Name}}<br>
                                Description : {{dt.Description}}
                            </vs-td>
                            <vs-td>
                                <table :key="idx_mt" v-for="(mt, idx_mt) in dt.MatrixJson">
                                    <tr>
                                        <th>Promotion</th>
                                        <th>Parameter</th>
                                        <th>Count</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            Code : {{ mt.V2Promotion.Code }} <br>
                                            Name : {{ mt.V2Promotion.Name }} <br>
                                            Description : {{ mt.V2Promotion.Description }}
                                        </td>
                                        <td>
                                            <span class="matrix_param" title="View Sales Area" :style="matrixParameterStyle" @click="clickView(mt.SalesAreaID, 1)">Sales Area</span><br>
                                            <span class="matrix_param" title="View Territory" :style="matrixParameterStyle" @click="clickView(mt.TerritoryID, 2)">Territory</span><br>
                                            <span class="matrix_param" title="View Distribution Channel" :style="matrixParameterStyle" @click="clickView(mt.CustomerCategoryID, 3)">Distribution Channel</span><br>
                                            <span class="matrix_param" title="View Customer Group" :style="matrixParameterStyle" @click="clickView(mt.CustomerGroupID, 4)">Customer Group</span><br>
                                            <span class="matrix_param" title="View Pricing" :style="matrixParameterStyle" @click="clickView(mt.PricingGroupID, 5)">Pricing</span><br>
                                            <span class="matrix_param" title="View Payment Term" :style="matrixParameterStyle" @click="clickView(mt.PaymentTermID, 6)">Payment Term</span><br>
                                            <span class="matrix_param" title="View Delivery Type" :style="matrixParameterStyle" @click="clickView(mt.DeliveryTypeID, 7)">Delivery Type</span>
                                        </td>
                                        <td>
                                            {{ dt.MatrixJson ? mt.SalesAreaID.length : 0 }}<br>
                                            {{ dt.MatrixJson ? mt.TerritoryID.length : 0 }}<br>
                                            {{ dt.MatrixJson ? mt.CustomerCategoryID.length : 0 }}<br>
                                            {{ dt.MatrixJson ? mt.CustomerGroupID.length : 0 }}<br>
                                            {{ dt.MatrixJson ? mt.PricingGroupID.length : 0 }}<br>
                                            {{ dt.MatrixJson ? mt.PaymentTermID.length : 0 }}<br>
                                            {{ dt.MatrixJson ? mt.DeliveryTypeID.length : 0 }}
                                        </td>
                                    </tr>
                                </table>
                            </vs-td>
                            <vs-td>
                                <feather-icon title="Edit" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click="clickEdit(dt)"/>
                                <feather-icon title="Delete" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="clickDelete(dt)"/>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>

                <vs-pagination style="padding-top:5px" :total="maxPage" v-model="currentPage" :prev-icon="$vs.rtl ? 'arrow_forward' : 'arrow_back'" :next-icon="$vs.rtl ? 'arrow_back' : 'arrow_forward'"/>
            </div>
        </div>
        <vs-popup fullscreen title="Form Matrix" :active.sync="popupForm"  @close="closeForm">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <formMatrix :selectedMatrix="selectedMatrix" v-on:closeForm="closeForm"></formMatrix>
                </div>
            </div>
        </vs-popup>
        <vs-popup title="Detail Parameter" :active.sync="popupParameter">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <tableParameterDetail :popupParameterType="popupParameterType" :dataParameter="dataParameter"></tableParameterDetail>
                </div>
            </div>
        </vs-popup>
    </div>
</template>


<script>
import formMatrix from "./form_matrix.vue";
import tableParameterDetail from "../component/table_parameter_detail.vue";
// import moment from 'moment'

export default {
    components: {
        formMatrix,
        tableParameterDetail
    },
    props:
        ["progress", "progressWarehouse", "progressRestriction", "isCancel","territory", "salesChannel", "customerCategory", "isClosed", "isBilled"],
        mounted() {
            // this.selectedMatrix = this.dataMatrix
        },
        data() {
            return {
                selectedMatrix: {},
                dataMatrix: [{}],
                dataParameter: [{}],

                limits: [10, 25, 50, 100, "All"],
                limitShow: 10,
                drawData: 0,
                isActive: 1,
                search: "",
                recordsTotal: 0,
                maxPage: 2,
                dataEnd: 0,

                popupForm: false,
                popupParameter: false,
                popupParameterType: 0,

                matrixParameterStyle: {
                    '--cursor': 'pointer',
                    '--hovercolor': 'blue',
                },
            };
        },
    watch: {
        watchedProperties: function() {
            this.getData();
        }
    },
    computed: {
        watchedProperties() {
            return `${this.territory}||${this.salesChannel}||${this.customerCategory}||${this.search}`;
        },
        currentPage: {
            get() {
                return 1;
            },
            set(page) {
                this.page(page);
            }
        }
    },
    methods: {
        dateFormat(date) {
            if (date) {
                // return moment(String(date)).utcOffset(0).format('DD/MM/YYYY hh:mm')
                let dt = new Date(date)
                let d = dt.getDate()
                let m = dt.getMonth()+1
                let y = dt.getFullYear()
                return d+"/"+m+"/"+y
            }
        },

        scrollToTop() {
            window.scrollTo(0,0);
        },

        clickEdit(data) {
            this.selectedMatrix = data
            this.popupParameter = false
            this.popupParameterType = 0
            this.popupForm = true
        },

        clickCreate() {
            this.selectedMatrix = {}
            this.popupParameter = false
            this.popupParameterType = 0
            this.popupForm = true
        },

        closeForm() {
            this.selectedMatrix = {}
            this.popupParameter = false
            this.popupParameterType = 0
            this.popupForm = false
            this.getData()
        },

        clickView(arr_id, type) {
            this.getParameterMatrix(arr_id, type)
        },

        clickDelete(data) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "You are about to cancel '"+data.Code+"' ?",
                accept: this.actionDelete,
                parameters: data
            });
        },

        actionDelete(data) {
            this.$vs.loading();
            this.$http
                .post("api/v2/promotion-matrix/cancel", {
                    id: data.ID,
                    code: data.Code,
                })
                .then(resp => {
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: "Promotion Matrix successfully cancelled",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle"
                        });
                        this.getData();
                        this.$vs.loading.close();
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle"
                        });
                        this.getData();
                        this.$vs.loading.close();
                    }
            });
        },

        page(page) {
            this.getData(page);
            return page;
        },

        changeLimit(limit) {
            this.limitShow = limit;
            this.getData(this.isActive);
        },

        getData(page = 1) {
            this.isActive = page;
            this.$vs.loading();

            var parameter = {
                search: this.search,
                limit: this.limitShow,
                offset: this.limitShow * (page - 1)
            };

            this.$http.get("/api/v2/promotion-matrix", {
                params: parameter
            }).then(resp => {
                if (resp.code == 200) {
                    this.drawData = this.drawData + 1;
                    this.dataMatrix = resp.data.PromotionMatrixes;
                    this.recordsTotal = resp.data.RecordsTotal;
                    this.maxPage = Math.ceil(this.recordsTotal / this.limitShow);
                    this.dataEnd = resp.data.ResultsTotal;
                    this.$vs.loading.close();
                } else {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle"
                    });
                }
            });
        },

        getParameterMatrix(arr_id, type) {
            var parameter = {
                ids: arr_id,
                type: type
            };

            this.$http.get("/api/v2/promotion-matrix/parameter", {
                params: parameter
            }).then(resp => {
                if (resp.code == 200) {
                    this.dataParameter = resp.data.PromotionMatrixParameters;
                    this.popupForm = false
                    this.popupParameter = true
                    this.popupParameterType = type
                } else {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle"
                    });
                }
            });
        },
    }
};
</script>

<style>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>
